






























































import Vue, { PropOptions } from 'vue';
import SHeader from '../SHeader/SHeader.vue';

import { BreadCrumb } from '../../types';

export default Vue.extend({
  name: 'SCard',
  components: {
    SHeader,
  },
  props: {
    /**
     * @see src/components/SHeader/SHeader.vue#id
     */
    id: {
      type: String,
      required: false,
    },
    /**
     * A theme colour which is applied to the card content.
     * @see src/components/SHeader/SHeader.vue#theme
     */
    theme: {
      type: String,
      required: false,
      default: 'none',
    },
    /**
     * @see src/components/SHeader/SHeader.vue#title
     */
    title: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#subTitle
     */
    subTitle: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#description
     */
    description: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#subDescription
     */
    subDescription: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#icon
     */
    icon: {
      type: String,
      required: false,
    },
    /**
     *
     * @see src/components/SHeader/SHeader.vue#showIcon
     */
    showIcon: {
      type: Boolean,
      required: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#dense
     */
    dense: {
      type: Boolean,
      required: false,
    },
    /**
     * When true removes padding of the card content making it 'flush' with the header
     */
    flush: {
      type: Boolean,
      required: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#breadcrumbs
     */
    breadcrumbs: {
      required: false,
      type: Array,
    } as PropOptions<BreadCrumb[]>,
    /**
     * If the card content should be hidden
     */
    minimized: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If the card should take up the whole screen
     */
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#useLightToolbar
     */
    useLightToolbar: {
      type: Boolean,
      default: true,
    },
    /**
     * @see src/components/SHeader/SHeader.vue#tooltipColor
     */
    tooltipColor: {
      type: String,
      default: 'primary',
    },
    /**
     * @see src/components/SHeader/SHeader.vue#smallHeader
     */
    smallHeader: {
      type: Boolean,
      default: false,
    },
    /**
     * Adds a custom class to the card header.
     */
    headerClass: {
      type: String,
      required: false,
    },

  },
  data() {
    return {
      size: {
        width: 0,
        height: 0,
      },
    };
  },
  watch: {
    fullscreen(value) {
      document.documentElement.classList.toggle('prevent-scroll', value);
    },
  },
});
